<template>
    <div v-loading="loading">

        <div class="header-btn">
            <el-button type="warning" size="small" icon="el-icon-plus" @click="addCheckList"/>
        </div>

        <el-table
                class="data-table"
                :data="data"
                stripe
                style="...">
            <el-table-column
                    v-for="item in [
                      {prop:'name',label:'Name'},
                      {prop:'version',label:'Version'}]"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>

            <el-table-column label="Updated Date">
                <template slot-scope="s">
                    {{s.row.updated | timeFmt}}
                </template>
            </el-table-column>

            <el-table-column
                    header-align="center"
                    align="center"
                    label="Action">
                <template slot-scope="s">
                    <el-button type="primary" size="mini" icon="el-icon-edit" @click="editCheckList(s.row)">Edit</el-button>
                    <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteData(s.row.id)">Del</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination v-if="page.total>1"
                           @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>

        <el-dialog
                v-if="dialogVisible"
                center
                width="65%"
                :close-on-click-modal="false"
                :visible.sync="dialogVisible">
            <el-form ref="forms" :model="checkListTemplates" label-position="left" label-width="120px"
                     :inline-message="true">

                <el-form-item label="Name" prop="name">
                    <el-input v-model="checkListTemplates.name" placeholder="Checklist Name"></el-input>
                </el-form-item>

                <el-form-item label="Description" prop="description">
                    <el-input v-model="checkListTemplates.description" placeholder="Checklist Description"
                              type="textarea"></el-input>
                </el-form-item>

                <el-form-item label-width="0">
                    <div class="item-add-btn">
                        <el-button type="warning" size="small" icon="el-icon-plus" @click="filed.push({})"></el-button>
                    </div>

                    <el-row v-for="(item, index) in filed" :key="index" style="margin-top: 1rem">
                        <div class="form-inline">

                            <el-button @click="filed.splice(index,1)" size="small" type="danger" icon="el-icon-delete"
                                       style="margin-right: 15px"></el-button>

                            <el-input v-model="item.fieldName" placeholder="Field Name" style="width: 200px;margin-right: 15px"></el-input>

                            <el-select v-model="item.type" placeholder="Field Type" style="width: 200px;margin-right: 15px">
                                <el-option
                                        v-for="option in [{label:'Select',value:'SELECT'},
                                                  {label:'CheckBox',value:'CHECKBOX'},
                                                  {label:'File',value:'UPLOADER'},
                                                  {label:'Input',value:'INPUT'}]"
                                        :key="option.value"
                                        :label="option.label"
                                        :value="option.value">
                                </el-option>
                            </el-select>

                            <el-input v-model="item.fieldOption" type="textarea" v-if="item.type ==='SELECT'"
                                      style="width: 250px;margin-right: 15px;" :rows="4"
                                      placeholder="The values for user choice"></el-input>

                            <el-input v-model="item.fieldPlaceholder" v-if="item.type ==='INPUT'" style="width: 250px;margin-right: 15px"
                                      placeholder="Suggested Input Description"></el-input>
                        </div>
                    </el-row>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="success" size="medium" @click="openPre" icon="el-icon-view">Preview</el-button>
                <el-button type="primary" size="medium" @click="save" icon="el-icon-edit">Save</el-button>
            </span>

            <el-dialog
                    center
                    append-to-body
                    title="Preview"
                    :visible.sync="preDialog"
                    width="40%">
                <el-form label-width="120px" label-position="left">
                    <el-form-item v-for="(item,index) in preData" :label="item.fieldName" :key="'prv'+index">
                        <el-input v-model="item.fieldValue" :placeholder="item.fieldPlaceholder"
                                  v-if="item.type==='INPUT'"></el-input>

                        <el-select v-model="item.fieldValue" v-else-if="item.type==='SELECT'"
                                   placeholder="Please Select">
                            <el-option
                                    v-for="op in toArray(item.fieldOption,'\n')"
                                    :key="op"
                                    :label="op"
                                    :value="op">
                            </el-option>
                        </el-select>

                        <el-checkbox v-model="item.fieldValue" v-else-if="item.type==='CHECKBOX'"></el-checkbox>

                        <file-uploader disabled v-else-if="item.type==='UPLOADER'"></file-uploader>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
    import {format} from '../../../utils/Date'
    import {addCheckList, checkListType, updateCheckList, deleteCheckList} from '@/api/CheckListAPI'
    import FileUploader from '../../../components/FileUploader'

    export default {
        name: 'InventoryType',
        components: {FileUploader},
        data: function () {
            return {
                loading: true,
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                dialogVisible: false,
                filed: [],
                data: [],
                terms: [],
                checkListTemplates: {},
                preDialog: false,
                preData: []
            }
        },
        methods: {
            editCheckList(data) {
                this.checkListTemplates = data
                this.filed = JSON.parse(data.templates)
                this.dialogVisible = true
            },
            loadData() {
                this.$pageUtils(this, checkListType)
            },
            save() {
                this.checkListTemplates.templates = JSON.stringify(this.filed)
                if (!this.checkListTemplates.status) {
                    this.checkListTemplates.statusv = 1
                }
                const action = this.checkListTemplates.id ? updateCheckList : addCheckList
                action(this.checkListTemplates).then(() => {
                    this.dialogVisible = false
                    this.loadData()
                })
            },
            addCheckList() {
                this.dialogVisible = true
            },
            openPre() {
                this.preDialog = true
                this.preData = JSON.parse(JSON.stringify(this.filed))
            },
            deleteData(id) {
                this.$deleteRequest(this, deleteCheckList, id)
            }
        },
        mounted() {
            this.loadData()
        },
        filters: {
            timeFmt(time) {
                return format(time)
            }
        }

    }
</script>

<style scoped>
    .item-add-btn {
        width: 100%;
        text-align: right
    }

    .el-button{
        margin-right: 5px;
    }

    @media screen and (min-width: 1300px) {
        .form-inline {
            margin-left: 120px;
        }
    }
</style>
